import React from 'react';
import './SearchPage.css';
import { Button } from '@material-ui/core';
import SearchResult from './SearchResult';

function SearchPage() {
    return (
        <div className='searchPage'>
           <div className="searchPage__info">
               <p>62 Stays . 26 August to 30 August . 2 Guest</p>
               <h1> Stays nearby</h1>
               <Button variant='outlined' >Cancellation Flexibility</Button>
               <Button variant='outlined'>Type of place</Button>
               <Button variant='outlined'>Price</Button>
               <Button variant='outlined'>Rooms and Beds</Button>
               <Button variant='outlined'>More filters</Button>
           </div>
           <SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/12/26/learn_skills.jpg'
               location='Private room at the center of Lagos'
               title='Stay at this spacious Oyeniyi House'
               description='7 guests . 8 bedrooms . 8 bed . 7 shared bathrooms. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.93}
               price='$350/night'
               total='$920 total'
           />
           <SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/03/01/Home_Staging_Tips_for_Real_Estate_Photography.jpg'
               location='Eko Atlantic'
               title='Foreign visitors'
               description='6 guests .  3 bedrooms . 6 bed . 2 shared bathrooms. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.85}
               price='$350/night'
               total='$920 total'
           />
           <SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/03/01/Staging_Tips_for_Real_Estate_Photography.jpg'
               location='Private room on the mainland of Lagos'
               title='Stay at this spacious Oyeniyi House'
               description='3 guests . 2 bedrooms . 2 beds . 2 shared bathrooms. Kitchen . Free parking . Washing Machine'
               star={4.72}
               price='$150/night'
               total='$650 total'
           />
           <SearchResult 
               img='https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80' 
               location='Private room at the East of Lagos'
               title='Stay at this cozy room'
               description='2 guests . 1 bedroom . 1 bed . 1 shared bathroom.  Kitchen . Free parking'
               star={4.68}
               price='$200/night'
               total='$750 total'
           />
           <SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/12/26/get_real_estate_photography_instruction.jpg'
               location='Private room at the center of Lagos'
               title='50 mins ride to Unilag'
               description='2 guests . 1 bedroom . 2 beds . 1 shared bathroom. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.56}
               price='$150/night'
               total='$520 total'
           />
           <SearchResult 
               img='https://static.photocdn.pt/images/articles/2020/03/09/real_estate_photography_5.jpg'
               location='Private room at the center of Lagos'
               title='Stay at this spacious Ambivertcode House'
               description='4 guests . 3 bedrooms . 4 beds . 2 shared bathrooms. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.50}
               price='$240/night'
               total='$720 total'
           />
           <SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/02/20/bedroom_photography_tips.jpg'
               location='Private room at the center of Lagos'
               title='Stay at this cozy bedroom'
               description='1 guest . 1 bedroom . 1 bed . 1.5 shared bathrooms. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.48}
               price='$120/night'
               total='$250 total'
           />

<SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/12/24/real_estate_photography_tips_1.jpg'
               location='Private room at the center of Lagos'
               title='Independent luxury studio apartment'
               description='2 guests . 1 bedroom . 1 bed . 1.5 shared bathrooms. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.23}
               price='$250/night'
               total='$850 total'
           />

            
<SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/12/24/How_to_Take_Gorgeous_Interior_Real_Estate_Photos.jpg'
               location='Private room at the center of Lagos'
               title='40 mins to Eko Atlantic'
               description='2 guests . 1 bedroom . 2 beds . 1.5 shared bathrooms. Wifi . Kitchen . Free parking . Washing Machine'
               star={4.17}
               price='$300/night'
               total='$900 total'
           />


<SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/02/20/how_to_make_bedrooms_look_their_best.jpg'
               location='Private room at the center of Lagos'
               title='Spacious Peaceful Modern Bedroom'
               description='2 guest . 1 bedrooms . 2 beds . 1 shared bathroom. Wifi . Kitchen . Free parking . Washing Machine'
               star={3.92}
               price='$250/night'
               total='$720 total'
           />


                <SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/02/20/bedroom_photography_tips_1.jpg'
               location='Private room at the center of Lagos'
               title='5 Star Luxury Apartment'
               description='3 guests . 3 bedrooms . 4 beds . 2 shared bathrooms. Wifi . Kitchen . Washing Machine'
               star={3.85}
               price='$200/night'
               total='$750 total'
           />

<SearchResult 
               img='https://static.photocdn.pt/images/articles/2019/02/20/photographing_bedrooms.jpg'
               location='Private room at the center of Lagos'
               title='The cozy room in Lagos'
               description='3 guests . 4 bedrooms . 5 beds . 4 shared bathrooms. Wifi . Kitchen . Free parking'
               star={3.65}
               price='$180/night'
               total='$750 total'
           />
        </div>
    )
}

export default SearchPage
